module.exports = __webpack_public_path__ + "img/L_318_325.c1cf4bc1.png";